import { v4 as uuidv4 } from 'uuid';
import { MarketingCompensatedDiscountsProductsGrid } from './MarketingCompensatedDiscountsProductsGrid';
import i18n from '../../../../i18n';
import { MarketingCompensatedDiscountsProductsGridPluginSettings } from './MarketingCompensatedDiscountsProductsPluginSettings';

export const MarketingCompensatedDiscountsProductsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingCompensatedDiscountsProduct"),
        view: {
            content: MarketingCompensatedDiscountsProductsGridPluginSettings
                ? <MarketingCompensatedDiscountsProductsGrid gridId={uuidv4()} plugin={MarketingCompensatedDiscountsProductsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
